export default class cookieService {
  static setCookie = (cookies, name, value, path = "/") => {
    return cookies.set(name, value, { path: path });
  };

  static getCookie = (cookies, name) => {
    // return cookies.get(name);
  };

  static removeCookie = (cookies, name) => {
    return cookies.remove(name);
  };
}
